<div *ngIf="showUpsell" class="company-upsell-card">
  <!-- Header -->
  <div class="header">
    <span [innerHTML]="header"></span>
  </div>
  <button (click)="dismissUpsell()" class="h-fit z-10" phx-icon-button [phxIcon]="crossIcon" phxIconButtonSize="small"></button>
  <div class="body">
    <!-- Content -->
    <div class="content">
      <span [innerHTML]="body"></span>

      <div class="d-flex flex-row gap-13">
        <button
          *ngFor="let cta of CTAs"
          (click)="handleCTAClick(cta)"
          [phxButtonRole]="cta.action.is_primary ? 'primary' : 'secondary'"
          phx-button
        >{{ getCTAText(cta) }}
        </button>
      </div>
    </div>

    <!-- Image -->
    <img [ngStyle]="{transform: 'scale(' + assetTransform + ')', 'margin-top': assetMarginTop}" class="asset-img" [src]="assetURL" />
  </div>
</div>